export default __webpack_public_path__ + "static/media/unstaking-step-three-bnb-rosn.08fdbc17.svg";